import { render } from "./updatevendor.vue?vue&type=template&id=18e71be2"
import script from "./updatevendor.vue?vue&type=script&lang=js"
export * from "./updatevendor.vue?vue&type=script&lang=js"

import "./updatevendor.vue?vue&type=style&index=0&id=18e71be2&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__